import { getUserProfile } from "../../services/userProfile.service";
import { types } from "./types";

export const getUserProfileAction = (id) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
    const response = await getUserProfile(id);
  if (response?.status) {
    const result = response?.data?.data;
    dispatch({ type: types.USER_PROFILE, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.USER_PROFILE,
      payload: { error: response.error },
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};
